module.exports = __webpack_public_path__ + "static/media/wint-pepsico-logo-small.2845cdfd.png";